import { FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { FieldError } from "react-hook-form";
import { SwitchFieldSchema } from "@/types/form-generator-schema-type";

interface IProps {
    field: {
        name: string,
        value: boolean,
        onChange: (value: boolean) => void,
        onBlur: () => void,
    };
    label: string;
    placeholder?: string;
    className?: string;
    errorMessage: FieldError;
    props?: SwitchFieldSchema["props"];
}

const FormSwitch = ({ field, label, placeholder, className, errorMessage, props = {} }: IProps) => {
    return (
        <FormControl fullWidth className={className} margin="normal" variant="outlined">
            <FormControlLabel
                control={
                    <Switch
                        {...field}
                        {...props}
                        checked={!!field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                    />
                }
                label={label || placeholder}
            />
            {errorMessage?.message ? <FormHelperText error>{errorMessage?.message}</FormHelperText> : null}
        </FormControl>
    );
};

export default FormSwitch;
